import ModuleContext from 'CMFW/context/ModuleContext';
import { Loading } from 'components/common/Loading';
import React, { useContext } from 'react';

export const LoadingGrid: React.FC = () => {
  const { loadingGrid } = useContext(ModuleContext);
  if (loadingGrid) {
    return <Loading />;
  } else {
    return null;
  }
};
